import InternalContainer from './InternalContainer';
import React from 'react';
import type { InternalContainerProps } from './InternalContainer.types';

export default function (props: InternalContainerProps) {
  return <InternalContainer {...props} />;
}
